// src/components/laboral/PrimeraAudienciaView.jsx
import React, { useEffect, useMemo, useState } from "react";

import { notify } from "../../ui/notify";
import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Space,
  Alert,
  Image,
  Input,
  Select,
  Upload,
  Form,
  Popconfirm,
} from "antd";
import ScrollDatePicker from "../../calendar/ScrollDatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  prestacionesLabels,
  parsePrestaciones,
  formatFormaPago,
  formatTipoPago,
  resolveAbogadoNombre,
} from "./audienciaHelpers";
import { da } from "date-fns/locale";
import { useDispatch } from "react-redux";
import { actionConstanciaCumplimientoCreate } from "../../../redux/actions/conciliacion/conciliacion";

import {PATH} from "../../../redux/utils"

dayjs.locale("es");

const API_BASE = `${PATH}/uploads/conciliaciones/`;
const { Title, Text } = Typography;
const toFullUrl = (url,id) => {
  if (!url) return null;
  if (typeof url !== "string") return null;
  if (url.startsWith("http")) return url;
  return `${API_BASE}/${id}/${url}`;
};
const pickDoc = (doc) => {
  if (!doc) return { fileName: null, openUrl: null };
  console.log(doc)
  const openUrl =
    doc?.path ||
    (Array.isArray(doc?.previews) && doc.previews[0]?.url) ||
    doc?.preview_url ||
    null;

  const fileName =
    doc?.filename ||
    doc?.original_name ||
    doc?.name ||
    (openUrl ? String(openUrl).split("/").pop() : null);

  return { fileName, openUrl };
};

const openFile = (url,id) => {
  if (!url) return;
  const full = url.startsWith("http") ? url : `${API_BASE}${id}/${url}`;
  window.open(full, "_blank", "noopener,noreferrer");
};

const DocumentOpenBox = ({
  title,
  doc,
  emptyText,
  buttonText,
  variant = "primary", // "primary" | "dark"
  icon = "file-pdf", // FontAwesome solid icon (sin el prefijo fa-)
  badgeText = null, // ej: "Cumplimiento de Convenio"
  metaLeft = null,  // ej: "3.4 MB"
  metaRight = null, // ej: "Finalizado"
  id,
}) => {
  const { fileName, openUrl } = pickDoc(doc);
  const has = !!openUrl;

  return (
    <div className={`aud-doc-card ${variant === "dark" ? "is-dark" : ""}`}>
      <div className="aud-doc-card__row">
        {/* Icono */}
        <div className="aud-doc-card__icon">
          <i className={`fa-solid fa-${icon}`} />
        </div>

        {/* Contenido */}
        <div className="aud-doc-card__content">
          <div className="aud-doc-card__head">
            <div className="aud-doc-card__title">{title}</div>

            {badgeText && (
              <span className="aud-doc-card__badge">
                <span className="aud-doc-card__badge-dot" />
                {badgeText}
              </span>
            )}
          </div>

          <div className="aud-doc-card__filename">
            <i className="fa-solid fa-file" />
            {has ? (fileName || "Documento cargado") : emptyText}
          </div>

          {(metaLeft || metaRight) && (
            <div className="aud-doc-card__chips">
              {metaLeft && <span className="aud-doc-card__chip">{metaLeft}</span>}
              {metaRight && <span className="aud-doc-card__chip">{metaRight}</span>}
            </div>
          )}

        

          <div className="aud-doc-card__actions">
            <button
              className="aud-doc-card__btn custom-button"
              onClick={() => openFile(openUrl,id)}
              disabled={!has}
            >
              <span>{buttonText}</span>
              <i className="fa-solid fa-arrow-up-right-from-square" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


const mapStatusToResultado = (idStatus, incomparecencia) => {
  switch (idStatus) {
    case 2:
      return "convenio";
    case 3:
      return "diferimiento";
    case 4:
      return "no_conciliacion";
    case 5:
      return "archivo_solicitante";
    case 6:
      return "archivo_patron";
    case 7:
      return "convenio";
    default:
      if (incomparecencia) return "incomparecencia";
      return "desconocido";
  }
};

const fmtCurrencyOrDash = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  const num = Number(v);
  if (Number.isNaN(num)) return String(v);
  return `${num.toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
  })} MXN`;
};

function PrimeraAudienciaView({ data, header, onEdit, onDelete, abogadoIndex }) {
  const { Dragger } = Upload;
  const [constForm] = Form.useForm();
  const expedienteVal = header?.expediente || null;
  const dispatch = useDispatch();


const [constanciaFileList, setConstanciaFileList] = useState([]);

  // OJO: constanciaDoc depende de data, así que lo declaramos después de validar data.
  // Para no romper hooks, validamos data con un fallback:
  const safeData = data || {};
  console.log(safeData)

  const constanciaDoc = safeData.documento_constancia || null;
  
  const [constanciaUploading, setConstanciaUploading] = useState(false);
  const [constanciaDocState, setConstanciaDocState] = useState(constanciaDoc);

  useEffect(() => {
    setConstanciaDocState(constanciaDoc);
  }, [constanciaDoc]);

  // YA DESPUÉS haces el early return, pero SIN hooks debajo
  if (!data) return null;

  const documento = data.documento || null;

  const documentoPreviews = Array.isArray(documento?.previews)
    ? documento.previews
    : [];
    // === Constancia de cumplimiento (segundo PDF) ===


  const constanciaRecibida = data.is_constancia_documento == 1 && !!constanciaDoc;

  const constanciaPreviews = Array.isArray(constanciaDoc?.previews)
    ? constanciaDoc.previews
    : [];
  const constanciaPreviewUrl =
    constanciaPreviews.length > 0 && constanciaPreviews[0].url
      ? toFullUrl(constanciaPreviews[0].url,header.id)
      : null;

  const hasConstanciaPreview = !!constanciaPreviewUrl;
  // ← agrega esto

  // fecha de cumplimiento capturada en el formulario (no la fecha de subida del archivo)
  const constanciaFecha =
    data.fecha_cumplimiento ||
    data.fecha_constancia_documento ||
    constanciaDoc?.created_at ||
    null;
  const constanciaFechaTexto = constanciaFecha
    ? dayjs(constanciaFecha).format("DD/MM/YYYY")
    : null;

  const hasDocumentoPreview =
    documentoPreviews.length > 0 && documentoPreviews[0].url;
  const mainDocumentoPreviewUrl = hasDocumentoPreview
    ? toFullUrl(documentoPreviews[0].url,header.id)
    : null;

  const resultado =
    data.resultado ||
    mapStatusToResultado(data.id_conciliacion_status, data.incomparecencia);

  const resumenPretensiones =
    data.resumen_pretensiones_html || data.pretension_trabajador || "";

  // =========================
  // Prestaciones reclamadas
  // =========================
  const prestacionesRawPrimary = Array.isArray(data.prestaciones)
    ? data.prestaciones
    : null;
  const showConstanciaColumn = resultado === "convenio";

  const showDocumentoCard =
    hasDocumentoPreview || (showConstanciaColumn && hasConstanciaPreview);

  const prestacionesRawFallback =
    data.prestaciones !== undefined ? data.prestaciones : null;

  let prestacionesTabla = [];


  if (Array.isArray(prestacionesRawPrimary) && prestacionesRawPrimary.length) {
    prestacionesTabla = prestacionesRawPrimary.map((p) => {
      const codigo = p.prestacion || p.codigo || p;
      const monto =
        p.monto !== null && p.monto !== undefined && p.monto !== ""
          ? Number(p.monto)
          : null;
      return {
        codigo,
        label: prestacionesLabels[codigo] || codigo,
        monto,
      };
    });
  } else if (
    Array.isArray(prestacionesRawFallback) &&
    prestacionesRawFallback.length
  ) {
    if (typeof prestacionesRawFallback[0] === "object") {
      prestacionesTabla = prestacionesRawFallback.map((p) => {
        const codigo = p.prestacion || p.codigo || p;
        const monto =
          p.monto !== null && p.monto !== undefined && p.monto !== ""
            ? Number(p.monto)
            : null;
        return {
          codigo,
          label: prestacionesLabels[codigo] || codigo,
          monto,
        };
      });
    } else {
      const codigos = prestacionesRawFallback.map((c) => String(c));
      prestacionesTabla = codigos.map((c) => ({
        codigo: c,
        label: prestacionesLabels[c] || c,
        monto: null,
      }));
    }
  } else if (
    typeof prestacionesRawFallback === "string" &&
    prestacionesRawFallback.trim() !== ""
  ) {
    const codigos = parsePrestaciones(prestacionesRawFallback);
    prestacionesTabla = codigos.map((c) => ({
      codigo: c,
      label: prestacionesLabels[c] || c,
      monto: null,
    }));
  }
const handleGuardarCumplimientoView = async () => {
  try {
    const v = await constForm.validateFields();

    if (!expedienteVal) {
      notify.error({
        message: "Datos incompletos",
        description: "No se encontró el expediente.",
      });
      return;
    }

    if (!constanciaFileList.length) {
      notify.error({
        message: "Falta archivo",
        description: "Selecciona la constancia antes de guardar.",
      });
      return;
    }

    setConstanciaUploading(true);

    const file = constanciaFileList[0];
    console.log(safeData.documento)

    const payload = {
      id:safeData.documento.id_conciliacion,
       id_conciliacion_audiencia:safeData.id,
      expediente: String(expedienteVal),
      fecha_cumplimiento: v.fecha_cumplimiento
        ? dayjs(v.fecha_cumplimiento).format("YYYY-MM-DD")
        : null,
      estado_cumplimiento: v.estado_cumplimiento || "completo",
      notas_cumplimiento: v.notas_cumplimiento || "",
      file, // <-- archivo
    };

    await dispatch(
      actionConstanciaCumplimientoCreate(payload, (resp) => {

        // si tu backend regresa path/preview/filename, actualizas el state local
        // (esto es opcional y depende del response real)
        
        if (resp?.filename || resp?.path || resp?.url) {
          setConstanciaDocState((prev) => ({
            ...(prev || {}),
            filename: resp.filename || prev?.filename,
            path: resp.path || resp.url || resp.file_url || prev?.path,
            previews: resp.preview_url ? [{ url: resp.preview_url }] : (prev?.previews || []),
            created_at: resp.created_at || prev?.created_at,
          }));
        }
      })
    );

    notify.success({
      message: "Guardado",
      description: "Se guardó la constancia y el cumplimiento.",
    });

    constForm.resetFields();
    setConstanciaFileList([]);
    setConstanciaUploading(false);
  } catch (err) {
    notify.error({
      message: "Error",
      description: "No se pudo guardar. Revisa los campos e intenta de nuevo.",
    });
    setConstanciaUploading(false);
  }
};


  const totalPrestaciones = prestacionesTabla.reduce(
    (acc, p) => acc + (p.monto || 0),
    0
  );

  // =========================
  // Pagos de convenio
  // =========================
  const pagosConvenio = Array.isArray(data.pagos_convenio)
    ? data.pagos_convenio.map((p) => ({
        monto: p.monto,
        forma_pago: p.forma_pago,
        fecha: p.fecha,
        tipo_pago: p.tipo_pago,
      }))
    : [];

  const montoConvenioTotal =
    data.monto_convenio != null && data.monto_convenio !== ""
      ? Number(data.monto_convenio)
      : pagosConvenio.reduce((acc, p) => acc + Number(p.monto || 0), 0);

  const formaPagoConvenio =
    data.forma_pago_convenio != null && data.forma_pago_convenio !== ""
      ? data.forma_pago_convenio
      : pagosConvenio.length
      ? pagosConvenio[0].forma_pago
      : null;

  // =========================
  // Próximo pago pendiente del convenio (para la tarjeta de resultado)
  // =========================
  const HOY = dayjs().startOf("day");

  const formatDiffDias = (diff) => {
    if (diff === null || diff === undefined) return null;
    if (diff > 0) return `en ${diff} día${diff === 1 ? "" : "s"}`;
    if (diff === 0) return "vence hoy";
    const vencidoHace = Math.abs(diff);
    return `vencido hace ${vencidoHace} día${vencidoHace === 1 ? "" : "s"}`;
  };

  const pagosConvenioConFecha = pagosConvenio
    .filter((p) => p.fecha)
    .map((p) => ({ ...p, diffDias: dayjs(p.fecha).startOf("day").diff(HOY, "day") }))
    .sort((a, b) => a.diffDias - b.diffDias);

  const proximoPagoConvenio =
    pagosConvenioConFecha.find((p) => p.diffDias >= 0) ||
    pagosConvenioConFecha[pagosConvenioConFecha.length - 1] ||
    (data.fecha_pago_convenio
      ? {
          fecha: data.fecha_pago_convenio,
          forma_pago: formaPagoConvenio,
          diffDias: dayjs(data.fecha_pago_convenio).startOf("day").diff(HOY, "day"),
        }
      : null);

  const riesgosHtml = data.riesgos_detectados || data.riesgos || "";
  const motivoArchivo = data.motivo_archivo || data.motivo_resultado || "";

  const abogadoNombre =
    resolveAbogadoNombre(
      data.id_abogado,
      abogadoIndex,
      data.nombre_abogado
    ) || "—";

  // =========================
  // Flags de visibilidad por resultado
  // =========================

  // Objeto de reclamación:
  // - Se muestra en: no_conciliacion, diferimiento
  // - No se muestra en: archivo_solicitante, archivo_patron, incomparecencia, convenio
  const baseShowObjeto =
    (resumenPretensiones &&
      resumenPretensiones.replace(/<[^>]+>/g, "").trim() !== "") ||
    prestacionesTabla.length > 0;

  const showObjeto =
    baseShowObjeto &&
    resultado !== "convenio" &&
    resultado !== "archivo_solicitante" &&
    resultado !== "archivo_patron" &&
    resultado !== "incomparecencia";

  // Desarrollo de la negociación:
  // - Se muestra en: no_conciliacion, diferimiento
  // - No se muestra en: convenio, archivo_solicitante, archivo_patron, incomparecencia
  const hasNegociacionData =
    (data.propuesta_final_trabajador !== null &&
      data.propuesta_final_trabajador !== undefined &&
      data.propuesta_final_trabajador !== "") ||
    (data.propuesta_final_patron !== null &&
      data.propuesta_final_patron !== undefined &&
      data.propuesta_final_patron !== "");

  const showNegociacion =
    hasNegociacionData &&
    resultado !== "convenio" &&
    resultado !== "archivo_solicitante" &&
    resultado !== "archivo_patron" &&
    resultado !== "incomparecencia";

  // Pagos de convenio:
  // - Sólo en resultado === "convenio"
  const showPagosConvenio =
    resultado === "convenio" && pagosConvenio.length > 0;

  // Motivo de archivo / constancia:
  // - Sólo en resultados de archivo
  const showMotivoArchivo =
    (resultado === "archivo_solicitante" ||
      resultado === "archivo_patron") &&
    motivoArchivo.trim() !== "";

  // =========================
  // Alert
  // =========================

  let alertType = "info";
  let alertMessage = "Resultado de la audiencia";
  let alertDescription =
    "Resultado registrado para esta audiencia prejudicial.";

  if (resultado === "convenio") {
    alertType = "danger";
    alertMessage = "CONVENIO CELEBRADO";
    alertDescription =
      "Se celebró convenio prejudicial en esta audiencia, con monto y forma de pago registrados.";
  } else if (resultado === "no_conciliacion") {
    alertType = "black";
    alertMessage = "NO HUBO CONVENIO";
    alertDescription =
      "La audiencia concluyó sin convenio; se registró la no conciliación.";
  } else if (resultado === "diferimiento") {
    alertType = "info";
    alertMessage = "AUDIENCIA DIFERIDA / NUEVA FECHA";
    alertDescription =
      "La audiencia se difirió y se programó una nueva fecha para continuar la negociación.";
  } else if (
    resultado === "archivo_solicitante" ||
    resultado === "archivo_patron"
  ) {
    alertType = "black";
    alertMessage = "ASUNTO ARCHIVADO";
    alertDescription =
      "El expediente fue archivado conforme al resultado registrado en esta audiencia.";
  } else if (resultado === "incomparecencia") {
    alertType = "black";
    alertMessage = "INCOMPARECENCIA";
    alertDescription =
      "Se levantó constancia de incomparecencia en esta audiencia prejudicial.";
  }

  // =========================
  // Tarjeta de resultado (título/ícono/color unificados)
  // =========================
  const resultadoTitleMap = {
    convenio: "Convenio celebrado",
    no_conciliacion: "No hubo convenio",
    diferimiento: "Audiencia diferida / nueva fecha",
    archivo_solicitante: "Asunto archivado",
    archivo_patron: "Asunto archivado",
    incomparecencia: "Incomparecencia",
  };
  const resultadoIconMap = {
    convenio: "fa-calendar-check",
    no_conciliacion: "fa-circle-xmark",
    diferimiento: "fa-calendar-check",
    archivo_solicitante: "fa-box-archive",
    archivo_patron: "fa-box-archive",
    incomparecencia: "fa-user-slash",
  };
  const resultadoTitle = resultadoTitleMap[resultado] || alertMessage;
  const resultadoIcon = resultadoIconMap[resultado] || "fa-circle-info";

  let resultadoRight = null;
  if (resultado === "diferimiento" && data.fecha_proxima_audiencia) {
    const fechaProxima = dayjs(data.fecha_proxima_audiencia);
    const diffDiasProxima = fechaProxima.startOf("day").diff(HOY, "day");
    resultadoRight = (
      <>
        <div className="audiencia-resultado-card__big">
          {fechaProxima.format("D MMM YYYY")}
        </div>
        <div className="audiencia-resultado-card__sub">
          {fechaProxima.format("HH:mm")} · {formatDiffDias(diffDiasProxima)}
        </div>
      </>
    );
  } else if (resultado === "convenio") {
    resultadoRight = constanciaRecibida ? (
      <>
        <div className="audiencia-resultado-card__big">Convenio cumplido</div>
        <div className="audiencia-resultado-card__sub">
          {constanciaFechaTexto
            ? `Cumplimiento registrado el ${constanciaFechaTexto}`
            : "Cumplimiento registrado"}
        </div>
      </>
    ) : proximoPagoConvenio ? (
      <>
        <div className="audiencia-resultado-card__big">
          {dayjs(proximoPagoConvenio.fecha).format("D MMM YYYY")}
        </div>
        <div className="audiencia-resultado-card__sub">
          {formatFormaPago(proximoPagoConvenio.forma_pago)} ·{" "}
          {formatDiffDias(proximoPagoConvenio.diffDias)}
        </div>
      </>
    ) : (
      <div className="audiencia-resultado-card__big">
        Fecha de pago no definida
      </div>
    );
  }

  // =========================
  // Desarrollo de la negociación: barra y brecha
  // =========================
  const fmtMontoSinDecimales = (v) => {
    const num = Number(v);
    if (v === null || v === undefined || v === "" || Number.isNaN(num))
      return "—";
    return num.toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
      maximumFractionDigits: 0,
    });
  };

  const negociacionTrabajador = Number(data.propuesta_final_trabajador) || 0;
  const negociacionPatron = Number(data.propuesta_final_patron) || 0;
  const brechaNegociacion = Math.abs(
    negociacionTrabajador - negociacionPatron
  );

  const riesgosBlock = (
    <div
      className={`audiencia-riesgos-block ${
        riesgosHtml ? "is-warning" : "is-ok"
      }`}
    >
      <div className="audiencia-riesgos-block__icon">
        <i
          className={`fa-solid ${
            riesgosHtml ? "fa-triangle-exclamation" : "fa-shield-halved"
          }`}
        />
      </div>
      <div className="audiencia-riesgos-block__content">
        {riesgosHtml ? (
          <>
            <div className="audiencia-riesgos-block__title">
              Riesgos detectados
            </div>
            <div
              className="audiencia-html"
              dangerouslySetInnerHTML={{ __html: riesgosHtml }}
            />
          </>
        ) : (
          <>
            <div className="audiencia-riesgos-block__title">
              Sin riesgos registrados
            </div>
            <div className="audiencia-riesgos-block__desc">
              No se detectaron riesgos en esta audiencia.
            </div>
          </>
        )}
      </div>
    </div>
  );

  return (
    <Card
      className="laboral-exp-audiencia-card"
      style={{ marginTop: 32, marginBottom: 32 }}
      bodyStyle={{ padding: 32 }}
    >
      <Row justify="space-between" align="top" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={4} style={{ marginBottom: 6 }}>
            Primera audiencia prejudicial
          </Title>
          <Text type="secondary">
            Resumen completo de la primera sesión de negociación.
          </Text>
          {data?.fecha_audiencia && (
            <div className="audiencia-fecha-label">
              <i className="fa-solid fa-calendar-day" />
              {dayjs(data.fecha_audiencia).format("D [de] MMMM [de] YYYY")}
            </div>
          )}
        </Col>
        <Col style={{ textAlign: "right" }}>
          <Space>
            {onDelete && (
              <Popconfirm
                title="Eliminar información de la audiencia"
                description={
                  <span>
                    Se borrará toda la información capturada en esta primera
                    audiencia y quedará como si nunca se hubiera registrado.
                    Esta acción no se puede deshacer.
                  </span>
                }
                okText="Sí, eliminar"
                cancelText="Cancelar"
                okButtonProps={{ danger: true }}
                onConfirm={onDelete}
              >
                <Button danger icon={<i className="fa-solid fa-trash" />} className="audiencia-btn-danger">
                  Eliminar información
                </Button>
              </Popconfirm>
            )}
            <Button
              type="primary"
              icon={<i className="fa-solid fa-pen" />}
              className="custom-button"
              onClick={onEdit}
            >
              Editar
            </Button>
          </Space>

          <div className="audiencia-header-abogado">
            <div className="audiencia-header-abogado-icon">
              <i className="fa-solid fa-user-tie" />
            </div>
            <div className="audiencia-header-abogado-text">
              <div className="audiencia-header-abogado-label">
                Abogado / apoderado legal
              </div>
              <div className="audiencia-header-abogado-name">
                {abogadoNombre}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="audiencia-header-divider" />

      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {/* RESULTADO DE LA AUDIENCIA */}
        <div className={`audiencia-resultado-card audiencia-resultado-card--${alertType}`}>
          <div className="audiencia-resultado-card__left">
            <div className="audiencia-resultado-card__title">
              <i className={`fa-solid ${resultadoIcon}`} />
              <span>{resultadoTitle}</span>
            </div>
            <div className="audiencia-resultado-card__desc">
              {alertDescription}
            </div>
          </div>
          {resultadoRight && (
            <div className="audiencia-resultado-card__right">
              {resultadoRight}
            </div>
          )}
        </div>

        {/* Motivo del archivo / constancia + RIESGOS (misma fila) */}
        {showMotivoArchivo && (
          <Row gutter={[20, 20]} align="stretch">
            <Col xs={24} md={12}>
              <div className="audiencia-summary-card">
                <div className="audiencia-summary-header">
                  Motivo del archivo / constancia
                </div>
                <div className="audiencia-summary-body">
                  <div className="audiencia-summary-row">
                    <div className="audiencia-summary-value">
                      {motivoArchivo}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              {riesgosBlock}
            </Col>
          </Row>
        )}

        {/* Pagos de convenio + RIESGOS (misma fila, sólo en CONVENIO) */}
        {showPagosConvenio && (
          <Row gutter={[20, 20]} align="stretch">
            <Col xs={24} md={12}>
              <div className="audiencia-summary-card">
                <div className="audiencia-summary-header">
                  Pagos registrados del convenio
                </div>
                <div className="audiencia-summary-body pagos">
                  <table className="audiencia-table resumen">
                    <thead>
                      <tr>
                        <th style={{ width: "8%" }}>#</th>
                        <th style={{ width: "24%" }}>Monto</th>
                        <th style={{ width: "24%" }}>Fecha</th>
                        <th style={{ width: "24%" }}>Forma de pago</th>
                        <th style={{ width: "24%" }}>Tipo de pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pagosConvenio.map((p, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{fmtCurrencyOrDash(p.monto)}</td>
                          <td>
                            {p.fecha
                              ? dayjs(p.fecha).format("DD/MM/YYYY")
                              : "—"}
                          </td>
                          <td>{formatFormaPago(p.forma_pago)}</td>
                          <td>{formatTipoPago(p.tipo_pago)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              {riesgosBlock}
            </Col>
          </Row>
        )}

        {/* OBJETO DE LA RECLAMACIÓN */}
        {showObjeto && (
          <div className="audiencia-plain-section">
            <div className="audiencia-section-label">
              Objeto de la reclamación
            </div>
            <Row gutter={[32, 16]} style={{ marginTop: 12 }}>
              <Col xs={24} md={12}>
                <Title level={5} className="audiencia-subtitle">
                  Pretensiones del trabajador
                </Title>

                <div
                  className="audiencia-html"
                  dangerouslySetInnerHTML={{
                    __html: resumenPretensiones,
                  }}
                />
              </Col>

              <Col xs={24} md={12}>
                <Title level={5} className="audiencia-subtitle">
                  Prestaciones reclamadas
                </Title>

                {prestacionesTabla.length === 0 ? (
                  <span className="audiencia-empty-state">
                    <i className="fa-solid fa-circle-check" />
                    Sin prestaciones marcadas.
                  </span>
                ) : (
                  <div className="audiencia-table-container">
                    <table className="audiencia-table detalle">
                      <thead>
                        <tr>
                          <th>Prestación</th>
                          <th>Monto estimado (MXN)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prestacionesTabla.map((p) => (
                          <tr key={p.codigo}>
                            <td>{p.label}</td>
                            <td>
                              {p.monto != null
                                ? p.monto.toLocaleString("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  })
                                : "—"}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th>Total estimado</th>
                          <td>
                            {totalPrestaciones > 0
                              ? totalPrestaciones.toLocaleString("es-MX", {
                                  style: "currency",
                                  currency: "MXN",
                                })
                              : "—"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        )}

        {/* DESARROLLO DE LA NEGOCIACIÓN + RIESGOS (misma fila) */}
        {showNegociacion ? (
          <Row gutter={[20, 20]} align="stretch">
            <Col xs={24} md={12}>
              <div className="audiencia-plain-section">
                <div className="audiencia-section-label">
                  Desarrollo de la negociación
                </div>
                <div className="audiencia-negociacion-amounts">
                  <div className="audiencia-negociacion-amount-col">
                    <div className="audiencia-negociacion-label-row">
                      <span className="audiencia-negociacion-dot audiencia-negociacion-dot--trabajador" />
                      <span className="audiencia-negociacion-label">
                        Propuesta final del trabajador
                      </span>
                    </div>
                    <div className="audiencia-negociacion-amount">
                      {fmtMontoSinDecimales(data.propuesta_final_trabajador)}{" "}
                      <span className="cur">MXN</span>
                    </div>
                  </div>
                  <div className="audiencia-negociacion-amount-col">
                    <div className="audiencia-negociacion-label-row">
                      <span className="audiencia-negociacion-dot audiencia-negociacion-dot--patron" />
                      <span className="audiencia-negociacion-label">
                        Propuesta final del patrón
                      </span>
                    </div>
                    <div className="audiencia-negociacion-amount">
                      {fmtMontoSinDecimales(data.propuesta_final_patron)}{" "}
                      <span className="cur">MXN</span>
                    </div>
                  </div>
                </div>
                <div className="audiencia-negociacion-brecha">
                  <span>Brecha entre propuestas</span>
                  <span className="audiencia-negociacion-brecha__amount">
                    {fmtMontoSinDecimales(brechaNegociacion)}
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              {riesgosBlock}
            </Col>
          </Row>
        ) : (
          !showPagosConvenio && !showMotivoArchivo && riesgosBlock
        )}
{/* DOCUMENTO NO CONCILIACIÓN */}
{resultado === "no_conciliacion" && documento && (
  <Card
    size="small"
    type="inner"
    title="Documento de la audiencia"
    className="audiencia-view-card"
  >
    <div className="aud-doc-grid">
      <DocumentOpenBox
        title="Constancia de no conciliación"
        doc={documento}
        emptyText="Aún no se ha subido la constancia de no conciliación."
        buttonText="Ver Constancia"
        variant="primary"
        icon="file-pdf"
        id={header.id}
        metaLeft={documento?.size_mb ? `${documento.size_mb} MB` : null}
        metaRight={documento?.status_text || "Finalizado"}
      />
    </div>
  </Card>
)}

{/* DOCUMENTO DE LA AUDIENCIA (CONVENIO + CONSTANCIA) */}
{resultado === "convenio" && (
  <Card
    size="small"
    type="inner"
    title="Documento de la audiencia"
    className="audiencia-view-card"
  >
    <div className="aud-doc-grid">
      {/* Convenio */}
      <DocumentOpenBox
        title="Documento del convenio"
        doc={documento}
        emptyText="Aún no se ha subido el documento del convenio."
        buttonText="Ver Documento"
        variant="primary"
        icon="file-pdf"
        id={header.id}
        metaLeft={documento?.size_mb ? `${documento.size_mb} MB` : null}
        metaRight={documento?.status_text || "Finalizado"}
      />

      {(() => {
  const hasConstancia = !!pickDoc(constanciaDocState).openUrl;

  return (
    <div className="aud-doc-card is-constancia">
      <div className="aud-doc-card__row">
        <div className="aud-doc-card__icon">
          <i className="fa-solid fa-circle-check" />
        </div>

        <div className="aud-doc-card__content">
          {/* ====== HEADER (solo si YA hay constancia) ====== */}
          {hasConstancia && (
            <>
              <div className="aud-doc-card__head">
                <div className="aud-doc-card__title">Constancia de Cumplimiento</div>

                
              </div>

              <div className="aud-doc-card__filename">
                <i className="fa-solid fa-file" />
                {pickDoc(constanciaDocState).fileName || "Documento cargado"}
              </div>

              <div className="aud-doc-card__chips">
                <span className="aud-doc-card__chip">
                  <i className="fa-solid fa-weight-hanging" />
                  {constanciaDocState?.size_mb ? `${constanciaDocState.size_mb} MB` : "—"}
                </span>
                <span
                  className={`aud-doc-card__chip ${
                    constanciaRecibida ? "is-success" : "is-pending"
                  }`}
                >
                  <i className={`fa-solid ${constanciaRecibida ? "fa-circle-check" : "fa-clock"}`} />
                  {constanciaRecibida ? "Validado" : "Pendiente"}
                </span>
                {constanciaFechaTexto && (
                  <span className="aud-doc-card__chip">
                    <i className="fa-solid fa-calendar-check" />
                    Fecha de cumplimiento: {constanciaFechaTexto}
                  </span>
                )}
              </div>

             

              <div className="aud-doc-card__actions">
                <button
                  className="aud-doc-card__btn custom-button"
                  onClick={() => openFile(pickDoc(constanciaDocState).openUrl,header.id)}
                >
                  <span>Ver Constancia</span>
                  <i className="fa-solid fa-arrow-up-right-from-square" />
                </button>
              </div>
            </>
          )}

          {/* ====== FORM (solo si NO hay constancia) ====== */}
          {!hasConstancia && (
            <div className="aud-const-form aud-const-form--only">
              <div className="aud-const-form__title">Cumplimiento de Convenio</div>

              <Form
                form={constForm}
                layout="vertical"
                initialValues={{ estado_cumplimiento: "completo" }}
              >
                <Form.Item label="Cargar constancia de cumplimiento">
                  <Dragger
                    multiple={false}
                    maxCount={1}
                    accept=".pdf,.png,.jpg,.jpeg"
                    fileList={constanciaFileList}
                    beforeUpload={(file) => {
                      setConstanciaFileList([file]);
                      return false;
                    }}
                    onRemove={() => setConstanciaFileList([])}
                    showUploadList
                    disabled={constanciaUploading}
                  >
                    <p className="ant-upload-drag-icon aud-const-form__drag-icon">
                      <i className="fa-solid fa-inbox" />
                    </p>
                    <p style={{ fontWeight: 600 }}>Subir un archivo o arrastrar y soltar</p>
                    <p style={{ color: "#6b7280", fontSize: 12 }}>PDF, PNG, JPG hasta 10MB</p>
                  </Dragger>
                </Form.Item>

                <div className="aud-const-form__panel">
                  <Row gutter={[12, 0]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Fecha de cumplimiento"
                        name="fecha_cumplimiento"
                        rules={[{ required: true, message: "Selecciona la fecha." }]}
                      >
                        <ScrollDatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item label="Notas de cumplimiento" name="notas_cumplimiento">
                        <Input.TextArea rows={3} placeholder="Describe detalles adicionales..." />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                <div className="aud-const-form__actions">
                  <Button onClick={() => constForm.resetFields()}>Cancelar</Button>
                  <Button
                    type="primary"
                    onClick={handleGuardarCumplimientoView}
                    loading={constanciaUploading}
                  >
                    Guardar
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
})()}

    </div>
  </Card>
)}
      </Space>

      <style>
        {`
.laboral-exp-audiencia-card {
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);
}

/* Header */
.audiencia-header-value {
  font-weight: 500;
  color: #111827;
  font-size: 13px;
}

.audiencia-header-abogado {
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  margin-left: auto;
  margin-top: 32px;
  margin-bottom: 14px;
  padding: 6px 14px 6px 8px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(15, 34, 58, 0.05);
}

.audiencia-header-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0 0 20px;
}

.audiencia-fecha-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #0A539A;
}

/* Mismo hover-scale que .custom-button ("Editar"), para que el botón de
   eliminar (danger, sin clase custom) tenga la misma animación al pasar
   el mouse en vez de quedarse estático. */
.audiencia-btn-danger {
  transition: transform 0.2s ease-out, background-color 0.2s ease-out, color 0.2s ease-out;
}
.audiencia-btn-danger:hover {
  transform: scale(1.05);
  background-color: #DC2626 !important;
  border-color: #DC2626 !important;
  color: #ffffff !important;
}
.audiencia-btn-danger:active {
  transform: scale(1);
}

.audiencia-header-abogado-icon {
  width: 32px;
  height: 32px;
  border-radius: 0;
  background: #DCE9F5;
  color: #0A539A;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.audiencia-header-abogado-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: right;
}

.audiencia-header-abogado-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 700;
  color: #6b7280;
}

.audiencia-header-abogado-name {
  font-size: 14px;
  font-weight: 700;
  color: #0b1b2b;
  line-height: 1.25;
}

/* Tarjeta de resultado (acento por tipo) */
.audiencia-resultado-card {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid rgba(15, 23, 42, 0.08);
}

/* "info" = diferimiento: mismo ámbar que el badge "AUDIENCIA #N" del
   listado de expedientes (STATUS_PILL_HEX.yellow = #F59E0B), para que el
   color sea consistente en toda la app. */
.audiencia-resultado-card--info {
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.4);
}

.audiencia-resultado-card--success {
  background: var(--bs-success-bg-subtle);
}

/* "danger" = convenio: mismo rojo que el badge "CONVENIO" del listado de
   expedientes (STATUS_PILL_HEX.red = #DC2626), para que el color sea
   consistente en toda la app. */
.audiencia-resultado-card--danger {
  background: rgba(220, 38, 38, 0.12);
  border-color: rgba(220, 38, 38, 0.35);
}

/* "black" = no_conciliacion / archivo / incomparecencia: mismo negro que
   el badge "ARCHIVO" / "NO CONCILIACIÓN" del listado de expedientes
   (STATUS_PILL_HEX.black = #111827), en vez del ámbar de "warning". */
.audiencia-resultado-card--black {
  background: rgba(17, 24, 39, 0.08);
  border-color: rgba(17, 24, 39, 0.25);
}

.audiencia-resultado-card--warning {
  background: var(--bs-warning-bg-subtle);
}

.audiencia-resultado-card__left {
  flex: 1 1 260px;
  min-width: 220px;
}

.audiencia-resultado-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.audiencia-resultado-card__title i {
  font-size: 14px;
}

.audiencia-resultado-card--info .audiencia-resultado-card__title i {
  color: #F59E0B;
}

.audiencia-resultado-card--success .audiencia-resultado-card__title i {
  color: #16a34a;
}

.audiencia-resultado-card--danger .audiencia-resultado-card__title i {
  color: #DC2626;
}

.audiencia-resultado-card--black .audiencia-resultado-card__title i {
  color: #111827;
}

.audiencia-resultado-card--warning .audiencia-resultado-card__title i {
  color: #d97706;
}

.audiencia-resultado-card__desc {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7280;
}

.audiencia-resultado-card__right {
  text-align: right;
  flex: 0 0 auto;
}

.audiencia-resultado-card__big {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
}

.audiencia-resultado-card__sub {
  margin-top: 2px;
  font-size: 12px;
  color: #6b7280;
}

@media (max-width: 640px) {
  .audiencia-resultado-card__right {
    text-align: left;
  }
}

/* Secciones sin card (Objeto / Desarrollo) */
.audiencia-plain-section {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 20px;
  background: #ffffff;
  height: 100%;
  box-sizing: border-box;
}

.audiencia-section-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

.audiencia-empty-state {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9ca3af;
}

.audiencia-empty-state i {
  color: #9ca3af;
}

.audiencia-negociacion-amounts {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 18px;
}

.audiencia-negociacion-amount-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 140px;
}

.audiencia-negociacion-amount-col + .audiencia-negociacion-amount-col {
  padding-left: 24px;
  border-left: 1px solid #f1f5f9;
}

.audiencia-negociacion-label-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.audiencia-negociacion-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.audiencia-negociacion-dot--trabajador {
  background: #0A539A;
}

.audiencia-negociacion-dot--patron {
  background: #cbd5e1;
}

.audiencia-negociacion-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.audiencia-negociacion-amount {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.audiencia-negociacion-amount .cur {
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  margin-left: 2px;
}

.audiencia-negociacion-brecha {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 13px;
}

.audiencia-negociacion-brecha span:first-child {
  color: #6b7280;
}

.audiencia-negociacion-brecha__amount {
  font-weight: 700;
  font-size: 15px;
  color: #0A539A;
}

/* Bloque de riesgos (acento por estado) */
.audiencia-riesgos-block {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  height: 100%;
  box-sizing: border-box;
}

.audiencia-riesgos-block.is-ok {
  background: var(--bs-success-bg-subtle);
}

.audiencia-riesgos-block.is-warning {
  background: var(--bs-warning-bg-subtle);
}

.audiencia-riesgos-block__icon i {
  font-size: 16px;
}

.audiencia-riesgos-block.is-ok .audiencia-riesgos-block__icon i {
  color: #16a34a;
}

.audiencia-riesgos-block.is-warning .audiencia-riesgos-block__icon i {
  color: #d97706;
}

.audiencia-riesgos-block__title {
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.audiencia-riesgos-block__desc {
  margin-top: 2px;
  font-size: 13px;
  color: #6b7280;
}

.audiencia-subtitle {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.audiencia-view-card {
  border-radius: 16px !important;
  border-color: #e5e7eb !important;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
  margin-top: 8px;
}

.audiencia-view-card .ant-card-head {
  padding: 0 20px;
  min-height: 40px;
}

.audiencia-view-card .ant-card-head-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.audiencia-view-card .ant-card-body {
  padding: 20px 22px !important;
}

.audiencia-summary-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
  margin-top: 8px;
}

.audiencia-summary-header {
  background: #f9fafb;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.audiencia-summary-body {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.audiencia-summary-body.pagos {
  border-top: 1px solid #e5e7eb;
  margin-top: 0;
}

.audiencia-summary-row {
  display: grid;
  grid-template-columns: minmax(0, 220px) minmax(0, 1fr);
  gap: 8px;
  align-items: baseline;
  font-size: 13px;
}

@media (max-width: 768px) {
  .audiencia-summary-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

.audiencia-summary-label {
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 11px;
}

.audiencia-summary-value {
  font-weight: 500;
  color: #111827;
}

.audiencia-table-container {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 10px;
}

.audiencia-table.detalle {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.audiencia-table.detalle th {
  padding: 10px 16px;
  background: #f3f4f6;
  color: #374151;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.03em;
  border-bottom: 1px solid #e5e7eb;
}

.audiencia-table.detalle td {
  padding: 10px 16px;
  background: #ffffff;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
}

.audiencia-table.detalle tr:last-child th,
.audiencia-table.detalle tr:last-child td {
  border-bottom: none;
}

@media (max-width: 768px) {
  .audiencia-table.detalle tr {
    display: grid;
    grid-template-columns: 1fr;
  }

  .audiencia-table.detalle th {
    border-bottom: none;
  }

  .audiencia-table.detalle td {
    border-bottom: 1px solid #e5e7eb;
  }
}

.audiencia-riesgos-block .audiencia-html p {
  margin-bottom: 4px;
}

        `}
      </style>
    </Card>
  );
}

export default PrimeraAudienciaView;
